import { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';

let benefitsSwiperWr = document.querySelectorAll('.benefits-swiper-wr');

benefitsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    swiperOnResize('(max-width: 768px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1.1,
          spaceBetween: 14,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          breakpoints: {
            400: {
              slidesPerView: 1.2,
            },
            500: {
              slidesPerView: 1.5,
            },
            600: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        },
    );
  }
});